// extracted by mini-css-extract-plugin
module.exports = {"container":"_9KTaGsBI","slider":"_Yq6ONFxQ"};